module.exports = __webpack_public_path__ + "img/questionbank.c3920ce5.svg";